import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import cx from 'classnames';
import { usePopper } from './usePopper';
import { FLIP, PREVENT_OVERFLOW } from './modifiers';
import * as styles from './styles.css';

/**
 * Компонента для рендера элемента спозиционированного относительно другого элемента
 *
 * @export
 * @param {IPopperProps} { open, anchorEl, children }
 * @returns
 */
export function Popper(_ref) {
  var open = _ref.open,
      anchorRef = _ref.anchorRef,
      placement = _ref.placement,
      modifiers = _ref.modifiers,
      children = _ref.children,
      portal = _ref.portal,
      divProps = _objectWithoutProperties(_ref, ["open", "anchorRef", "placement", "modifiers", "children", "portal"]);

  var host = typeof document !== 'undefined' ? document.body : null;
  var popper = usePopper({
    open: open,
    anchorRef: anchorRef,
    options: {
      placement: placement,
      modifiers: modifiers
    }
  });

  if (!host || !open) {
    return null;
  }

  var popperElement = React.createElement("div", _extends({}, divProps, {
    className: cx(styles['popper'], divProps.className),
    ref: popper.ref
  }), children);
  return portal ? ReactDOM.createPortal(popperElement, host) : popperElement;
}
Popper.defaultProps = {
  modifiers: [FLIP, PREVENT_OVERFLOW],
  portal: true
};